
import React from "react";
import { Accordion, AccordionPanel, Panel } from '@ronuse/norseu/core/panels';
import Helpers from "../../../utils/Helpers";
import { Button } from "@ronuse/norseu/core/buttons";
import { Message, showMessage, showMessages } from "@ronuse/norseu/core/overlay";
import { Scheme } from "@ronuse/norseu/core/variables";

export class MessagePage extends React.Component {

    constructor(props) {
        super(props);
        this.willUnmount = false;
        this.previewPanels = React.createRef();
        this.previewPanels.current = [];
    }

    componentWillUnmount() {
        this.willUnmount = true;
    }

    buildDocumentation() {
        this.messagess = this.messagess || [];
        this.stickyMessages = this.stickyMessages || [];
        let customIcon1 = <img alt="norseu" src="https://avatars3.githubusercontent.com/u/69908664?s=16" style={{ borderRadius:"50%" }}/>;
        let customIcon2 = <img alt="norseu" src="https://avatars3.githubusercontent.com/u/14879387?s=16" style={{ borderRadius:"50%" }}/>;

        return (
            <React.Fragment>
                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Basic</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <Message icon={"fas fa-bell"} scheme={Scheme.PRIMARY} description={"Primary Message description"} fill sticky/>
                            <Message icon={"fas fa-bell-slash"} scheme={Scheme.SECONDARY} description={"Secondary Message secondary"} fill sticky/>
                            <Message icon={"fa fa-check-circle"} scheme={Scheme.SUCCESS} description={"Success Message success"} fill sticky/>
                            <Message icon={"fas fa-exclamation-circle"} scheme={Scheme.INFO} description={"Info Message info"} fill sticky/>
                            <Message icon={"fas fa-exclamation-triangle"} scheme={Scheme.WARNING} description={"Warning Message warning"} fill sticky/>
                            <Message icon={"fa fa-times-circle"} scheme={Scheme.DANGER} description={"Danger Message danger"} fill sticky/>
                            <Message icon={customIcon1} scheme={Scheme.DARK} description={"Dark Message danger"} fill sticky/>
                            <Message icon={customIcon2} scheme={Scheme.LIGHT} description={"Light Message danger"} fill sticky/>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Functional</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <div ref={(r) => this.messagesDiv = r}></div>
                            <Button text="Show Basic Message" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY} 
                                onClick={(e) => {
                                    console.log(this.messagesDiv)
                                    showMessage({
                                        container: this.messagesDiv,
                                        title: "Ronuse Message Component",
                                        description: "Show a message and attach to any container of choice",
                                        style: {  marginTop: "5px" }
                                    });
                                }} />

                            <Button text="No Icon" scheme={Scheme.DARK} 
                                onClick={(e) => {
                                    showMessage({
                                        icon: null,
                                        scheme: Scheme.DARK,
                                        container: this.messagesDiv,
                                        title: "Sticky Message",
                                        description: "Setting icon={null}, or icon: null will prevent rendering icon in the message",
                                        style: {  marginTop: "5px" }
                                    });
                                }} />

                            <Button text="Show Sticky Message" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.SUCCESS} 
                                onClick={(e) => {
                                    this.stickyMessages.push(showMessage({
                                        sticky: true,
                                        scheme: Scheme.SUCCESS,
                                        container: this.messagesDiv,
                                        title: "Sticky Message",
                                        description: "This does not close automatically, click the close button to close",
                                        style: {  marginTop: "5px" }
                                    }));
                                }} />

                            <Button text="Show Fill Message" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.WARNING} 
                                onClick={(e) => {
                                    showMessage({
                                        fill: true,
                                        scheme: Scheme.WARNING,
                                        container: this.messagesDiv,
                                        title: "Fill Message",
                                        description: "This type of messages fills the width of the parent container, fill=true",
                                        style: {  marginTop: "5px" }
                                    });
                                }} />
                            
                            <Button text="Clear Sticky Messages" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.SECONDARY}
                                onClick={(e) => this.stickyMessages?.forEach(messages =>messages.close()) || (this.stickyMessages = [])} />

                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>
                
                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Multiple Messages</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <div ref={(r) => this.multipleMessagesDiv = r}></div>
                            <Button text="Show Multiple Messages" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.PRIMARY}
                                onClick={(e) => {
                                    const messagesProps = {
                                        sticky: true,
                                        fill: true,
                                        container: this.multipleMessagesDiv,
                                        style: {  marginTop: "5px" },
                                    };
                                    this.messagess.push(showMessages([
                                        {
                                            scheme: Scheme.PRIMARY,
                                            title: "Primary Message",
                                            onClose: () => alert("We close this shit"),
                                            description: "This is a message part of multiple messages",
                                            ...messagesProps
                                        },
                                        {
                                            scheme: Scheme.SUCCESS,
                                            title: "Success Message",
                                            description: "This is a message part of multiple messages",
                                            ...messagesProps
                                        },
                                        {
                                            scheme: Scheme.WARNING,
                                            title: "Warning Message",
                                            description: "This is a message part of multiple messages",
                                            ...messagesProps
                                        },
                                        {
                                            scheme: Scheme.DANGER,
                                            title: "Danger Message",
                                            description: "This is a message part of multiple messages",
                                            ...messagesProps
                                        }
                                    ]));
                                }} />
                            
                            <Button text="Clear Messages" icon="fa fa-clone fa-flip-vertical" scheme={Scheme.SECONDARY}
                                onClick={(e) => this.messagess?.forEach(messages => messages.closeAll()) || (this.messagess = [])} />
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>
            </React.Fragment>
        );
    }

    render() {
        return Helpers.buildComponentPage(this, {
            title: "Message",
            import_statement: "import { Message } from '@ronuse/norseu/core/overlay'",
            properties: this.properties,
            css_map: this.cssMap,
            ref_map: this.refMap,
            documentation: this.buildDocumentation(),
            page_source: this.state.pageSource,
            show_dialog: this.state.showSourceDialog,
            source_url: "https://raw.githubusercontent.com/ronuse/norseu/main/showcase/src/components/core/overlay/MessagePage.js"
        });
    }

    state = {
        pageSource: '',
        showSourceDialog: false
    };

    cssMap = [

    ];

    properties = [
        { name: "text", type: "string", default: "", description: "The label to show in the button" },
    ];
    
    refMap = [
        { name: "value()", type: "function", description: "Returns the value of the component internal HTML element" },
        { name: "setValue(value)", type: "function", description: "Set the value of the component internal HTML element" },
        { name: "focus()", type: "function", description: "Send focus to the component" },
        { name: "getInternalElement()", type: "function", description: "Get the react reference to the internal element" },
        { name: "getState()", type: "function", description: "Get the current state of the component" },
        { name: "setState(newState)", type: "function", description: "Change the component state" },
    ]

}
